import { render } from "./AddLessons.vue?vue&type=template&id=382fda6f&scoped=true"
import script from "./AddLessons.vue?vue&type=script&lang=js"
export * from "./AddLessons.vue?vue&type=script&lang=js"

import "./AddLessons.vue?vue&type=style&index=0&id=382fda6f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382fda6f"]])

export default __exports__